const PRODUCT_VIEW_HISTORY_KEY = 'valley_product_view_history';
const MAX_HISTORY_ITEMS = 20;

const normalizeHistoryItem = (product) => {
  const id = Number(product?.idproducts);
  if (!Number.isInteger(id) || id < 1) return null;

  return {
    idproducts: id,
    product_brand: String(product.product_brand || '').trim(),
    product_category: String(product.product_category || '').trim()
  };
};

export const getProductViewHistory = () => {
  try {
    const storedHistory = JSON.parse(localStorage.getItem(PRODUCT_VIEW_HISTORY_KEY) || '[]');
    if (!Array.isArray(storedHistory)) return [];
    return storedHistory.map(normalizeHistoryItem).filter(Boolean).slice(0, MAX_HISTORY_ITEMS);
  } catch (error) {
    return [];
  }
};

export const recordProductView = (product) => {
  const viewedProduct = normalizeHistoryItem(product);
  if (!viewedProduct) return;

  try {
    const history = getProductViewHistory().filter(
      (item) => item.idproducts !== viewedProduct.idproducts
    );
    localStorage.setItem(
      PRODUCT_VIEW_HISTORY_KEY,
      JSON.stringify([viewedProduct, ...history].slice(0, MAX_HISTORY_ITEMS))
    );
  } catch (error) {
    // Recommendations remain optional when browser storage is unavailable.
  }
};

export const getRecommendationSignals = () => {
  const history = getProductViewHistory();
  return {
    brands: [...new Set(history.map((item) => item.product_brand).filter(Boolean))],
    categories: [...new Set(history.map((item) => item.product_category).filter(Boolean))],
    viewedProductIds: history.map((item) => item.idproducts)
  };
};

